export default {
  sendSession (VueApp, params, callback) {
    VueApp.$sdk.post23(VueApp, `/reservation/session`, params, res => {
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/service-session.js